import { TextArea, InputGroup } from '@blueprintjs/core';
import { DateInput } from '@blueprintjs/datetime';
import Clearfix from 'components/elements/clearfix';
import HinhThucSelect from 'components/elements/select-hinh-thuc-so-huu';
import NguonNuocSelect from 'components/elements/select-nguon-nuoc';
import { DATE_FORMAT, SELECT_ITEM_DEFAULT } from 'config';
import PageLockHOC from 'hoc/pageLock';
import moment from 'moment';
import PropTypes from 'prop-types';
import { createForm } from 'rc-form';
import NumberInput from 'rc-input-number';
import React from 'react';
// import * as _ from 'lodash';
import { Col, Row } from 'reactstrap';
import styled from 'styled-components';
import { convertDateFromSever as convertDate } from 'utils/fnUtil';
import ThongTinBCCTNH from './ThongTinBCCTNH';

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const FormRow = ({ left, right }) => {
  return (
    <Row>
      <Col xs={3}>{left}</Col>
      <Col xs={5}>{right}</Col>
    </Row>
  );
};

@PageLockHOC(['facility.write'])
class ChiTietCosoEdit extends React.Component {
  static propTypes = {
    initialValue: PropTypes.object,
  };
  state = {};

  setInitialValue = (keyPath, defaultValue) => {
    let value = _.result(this.props.initialValue, keyPath, defaultValue);
    if (!value) value = defaultValue;
    return value;
  };

  setSelInitialValue = (keyPath, defaultValue, nameLabel) => {
    let selItem = _.result(this.props.initialValue, keyPath);
    if (!selItem) return defaultValue;
    return {
      value: selItem._id,
      label: nameLabel ? selItem[nameLabel] : selItem.Name,
    };
  };

  getFieldPropsProcess = (name, defaultValue) => {
    const { getFieldProps } = this.props.form;
    const objectField = {
      ...getFieldProps(name, {
        initialValue: this.setInitialValue(name, defaultValue),
      }),
    };
    return objectField;
  };

  render() {
    const { getFieldProps } = this.props.form;

    return (
      <div style={{ width: '100%' }}>
        <Row>
          <Col xs={3}>
            <LabelContainer>
              <b>Giấy chứng nhận đầu tư</b>
            </LabelContainer>
          </Col>
        </Row>

        <FormRow
          left={<LabelContainer>Số giấy phép</LabelContainer>}
          right={
            <InputGroup
              placeholder='Số giấy phép'
              {...this.getFieldPropsProcess('InvestmentLicenseNumber', '')}
            />
          }
        />

        <FormRow
          left={<LabelContainer>Ngày cấp lần đầu</LabelContainer>}
          right={
            <DateInput
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              placeholder='Ngày cấp lần đầu'
              {...getFieldProps('InvestmentLicenseIssueDateFirst', {
                initialValue: convertDate(
                  this.setInitialValue('InvestmentLicenseIssueDateFirst', null)
                ),
              })}
            />
          }
        />

        <FormRow
          left={<LabelContainer>Ngày cấp lần gần nhất</LabelContainer>}
          right={
            <DateInput
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              placeholder='Ngày cấp lần gần nhất'
              {...getFieldProps('InvestmentLicenseIssueDateLast', {
                initialValue: convertDate(
                  this.setInitialValue('InvestmentLicenseIssueDateLast', null)
                ),
              })}
            />
          }
        />

        <FormRow
          left={
            <LabelContainer>
              <b>Giấy chứng nhận đăng ký doanh nghiệp</b>
            </LabelContainer>
          }
        />
        <FormRow
          left={<LabelContainer>Số giấy phép</LabelContainer>}
          right={
            <InputGroup
              placeholder='Số giấy phép'
              {...this.getFieldPropsProcess('BusinessLicenseNumber', '')}
            />
          }
        />
        <FormRow
          left={<LabelContainer>Ngày cấp lần đầu</LabelContainer>}
          right={
            <DateInput
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              placeholder='Ngày cấp lần đầu'
              {...getFieldProps('BusinessLicenseIssueDateFirst', {
                initialValue: convertDate(
                  this.setInitialValue('BusinessLicenseIssueDateFirst', null)
                ),
              })}
            />
          }
        />
        <FormRow
          left={<LabelContainer>Ngày cấp lần gần nhất</LabelContainer>}
          right={
            <DateInput
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              placeholder='Ngày cấp lần gần nhất'
              {...getFieldProps('BusinessLicenseIssueDateLast', {
                initialValue: convertDate(
                  this.setInitialValue('BusinessLicenseIssueDateLast', null)
                ),
              })}
            />
          }
        />

        <ThongTinBCCTNH
          form={this.props.form}
          setSelInitialValue={this.setSelInitialValue}
          setInitialValue={this.setInitialValue}
        />

        <FormRow
          left={
            <LabelContainer>
              <b>Thông tin khác</b>
            </LabelContainer>
          }
        />
        <FormRow
          left={<LabelContainer>Hình thức sở hữu</LabelContainer>}
          right={
            <HinhThucSelect
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'ownership',
                option: {
                  initialValue: this.setSelInitialValue(
                    'ownership',
                    SELECT_ITEM_DEFAULT
                  ),
                },
              }}
            />
          }
        />
        <FormRow
          left={<LabelContainer>Năm bắt đầu hoạt động</LabelContainer>}
          right={
            <NumberInput
              placeholder='Năm bắt đầu hoạt động'
              {...getFieldProps('YearsOfOperation', {
                initialValue: this.setInitialValue('YearsOfOperation', ''),
              })}
            />
          }
        />
        <Clearfix height={8} />
        <FormRow
          left={<LabelContainer>Số lượng công nhân viên</LabelContainer>}
          right={
            <NumberInput
              placeholder='Số lượng công nhân viên'
              {...getFieldProps('Employees', {
                initialValue: this.setInitialValue('Employees', ''),
              })}
            />
          }
        />
        <FormRow
          left={<LabelContainer>Công suất</LabelContainer>}
          right={
            <TextArea
              fill
              placeholder='Công suất'
              {...getFieldProps('Capacity', {
                initialValue: this.setInitialValue('Capacity', ''),
              })}
            />
          }
        />
        <Clearfix height={8} />
        <FormRow
          left={<LabelContainer>Quy trình sản xuất</LabelContainer>}
          right={
            <TextArea
              fill
              placeholder='Quy trình sản xuất'
              {...getFieldProps('ProductDesc', {
                initialValue: this.setInitialValue('ProductDesc', ''),
              })}
            />
          }
        />
        <Clearfix height={8} />
        <FormRow
          left={<LabelContainer>Nhiên liệu</LabelContainer>}
          right={
            <TextArea
              fill
              placeholder='Nhiên liệu'
              {...getFieldProps('Fuel', {
                initialValue: this.setInitialValue('Fuel', ''),
              })}
            />
          }
        />
        <Clearfix height={8} />
        <FormRow
          left={<LabelContainer>Số ngày làm việc trong tháng</LabelContainer>}
          right={
            <NumberInput
              placeholder='Số ngày làm việc trong tháng'
              {...getFieldProps('WorkingDaysMonth', {
                initialValue: this.setInitialValue('WorkingDaysMonth', ''),
              })}
            />
          }
        />
        <Clearfix height={8} />
        <FormRow
          left={<LabelContainer>Số ngày làm việc/năm</LabelContainer>}
          right={
            <NumberInput
              placeholder='Số ngày làm việc/năm'
              {...getFieldProps('WorkingDaysYear', {
                initialValue: this.setInitialValue('WorkingDaysYear', ''),
              })}
            />
          }
        />
        <FormRow
          left={<LabelContainer>Lượng nước sử dụng (m3/ngày)</LabelContainer>}
          right={
            <NumberInput
              placeholder='Lượng nước sử dụng (m3/ngày)'
              {...getFieldProps('WaterUseDay', {
                initialValue: this.setInitialValue('WaterUseDay', ''),
              })}
            />
          }
        />
        <FormRow
          left={<LabelContainer>Nguồn nước</LabelContainer>}
          right={
            <NguonNuocSelect
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'waterSource',
                option: {
                  initialValue: this.setSelInitialValue(
                    'waterSource',
                    SELECT_ITEM_DEFAULT
                  ),
                },
              }}
            />
          }
        />
        <Clearfix height={8} />
      </div>
    );
  }
}

export default createForm()(ChiTietCosoEdit);



// WEBPACK FOOTER //
// ./src/containers/Coso/CosoView/ChiTietCosoPanel/ChiTietCosoEdit/index.js